// extracted by mini-css-extract-plugin
module.exports = {"tooltip-content":"_40d5d0e87d--tooltip-content--qCVSz","tooltip-content-disabled":"_40d5d0e87d--tooltip-content-disabled--ODJbM"};